import { PromosStylesSchema } from './Promos.styles';

export const promosStyles: PromosStylesSchema = {
  body: {
    color: 'gray.700',
  },
  container: {
    mx: '-2',
    mt: '-3',
  },
};
